import { useEffect, useState } from "react";
import { RiMarkPenFill, RiUser2Fill, RiUser3Fill } from "react-icons/ri";
import ToggleButton from "../../../../../../../components/ui/toggle_button/ToggleButton";
import Questionnaire from "../../../../../../../libs/api/services/Questionnaire";
import PatientHistoryEvent from "../../../../../../../libs/api/services/PatientHistoryEvent";
import Patient from "../../../../../../../libs/api/services/Patient";
import { set } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSpinner,
  faCheckCircle,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
export default function FieldLinkContainer({ component, onPropertyChange }) {
  // Slide-in message state
  const [slideMessage, setSlideMessage] = useState(null); // { type: 'loading'|'success'|'error', text: string }
  const [showSlide, setShowSlide] = useState(false);
  // If component not already linked
  // Select link to user profile / patient profile  (with icon)
  // Select the field to link to
  // Select if the field is an autofill link or a records update link or both
  // If the field is an autofill link, then the field will be automatically filled with the linked field value
  // If the field is a records update link, then the linked field will be updated with the field value when the record is saved
  // else
  // Show the linked field and allow to change the link

  // Split the component into two parts
  // 1. The linked field
  // 2. The link type (autofill or records update)

  const handleLoadLinkedField = async () => {
    // Call returns a 404 if the field is not linked or
    // the linked field if linked
    Questionnaire.GetLinkPatientProfile(component.componentId)
      .then((field) => {
        console.log("Linked Field Loaded:", field);
        setLinkedField(field.linkedValue.id);
        let types = [];
        field.autoFill && types.push("autofill");
        field.updateRecords && types.push("recordsUpdate");
        setLinkTypes(types);
      })
      .catch(() => {
        // 404 not found
        // console.error("Error loading linked field:", error);
      });
  };
  // State to manage linked field and link type
  const [loading, setLoading] = useState(true);
  const [patientProfileFields, setPatientProfileFields] = useState([]);
  useEffect(() => {
    handleLoadPatientProfileFields();
    handleLoadLinkedField();
    setLoading(false);
  }, []);

  const [linkedField, setLinkedField] = useState(component.linkedField || null);
  // Allow multiple link types
  const [linkTypes, setLinkTypes] = useState(
    Array.isArray(component.linkType)
      ? component.linkType
      : component.linkType
      ? [component.linkType]
      : ["autofill"]
  );

  const handleLoadPatientProfileFields = async () => {
    // console.log(await Patient.Categories())
    setPatientProfileFields(
      await Promise.all(
        (
          await Patient.Categories()
        ).map(async (categoryResource) => {
          return {
            group: categoryResource.resource.groupNme,
            fields: (
              await Patient.LoadFields(categoryResource.resource.id)
            ).map((field) => ({
              id: field.resource.id,
              name: field.resource.value,
            })),
          };
        })
      )
    );
  };
  const handleLinkedFieldChange = (field) => {
    setLinkedField(field);
    onPropertyChange(component.componentId, "linkedField", field, false);
  };
  // Toggle link type selection
  const handleLinkTypeChange = (type) => {
    let updatedTypes;
    if (linkTypes.includes(type)) {
      updatedTypes = linkTypes.filter((t) => t !== type);
    } else {
      updatedTypes = [...linkTypes, type];
    }
    setLinkTypes(updatedTypes);
    onPropertyChange(component.componentId, "linkType", updatedTypes, false);
  };
  const handleLinkUpdate = async () => {
    setSlideMessage({ type: "loading", text: "Linking field..." });
    setShowSlide(true);
    // Wait at least 1 second for loader
    const start = Date.now();
    try {
      await Questionnaire.LinkPatientProfile(
        component.componentId,
        null,
        linkedField,
        {
          autoFill: linkTypes.includes("autofill"),
          updateRecords: linkTypes.includes("recordsUpdate"),
          linkedValue: { id: linkedField },
        }
      );
      const elapsed = Date.now() - start;
      setTimeout(() => {
        setSlideMessage({
          type: "success",
          text: "Field linked successfully!",
        });
        setTimeout(() => setShowSlide(false), 1000);
      }, Math.max(1000 - elapsed, 0));
    } catch (error) {
      const elapsed = Date.now() - start;
      setTimeout(() => {
        setSlideMessage({
          type: "error",
          text: error?.message || "Failed to link field.",
        });
      }, Math.max(1000 - elapsed, 0));
    }
  };
  const handleLinkRemove = () => {
    // Logic to remove the link
    setLoading(true);
    Questionnaire.UnLinkPatientProfile(component.componentId, linkedField)
      .then(() => {
        setLinkedField(null);
        setLinkTypes([]);
      })
      .catch((error) => {
        console.error("Error removing link:", error);
        setLoading(false);
      });
  };

  // Render the component
  if (!linkedField)
    return (
      <div className="text-center d-flex flex-column align-items-center">
        {/* <div className="text-center d-flex flex-column align-items-center p-2 border-bottom" onClick={() => handleLinkedFieldChange('userProfile')}>
                    <RiUser2Fill size={70} />
                    <b>Link to User Profile</b>
                    <p className="text-muted">Link this field to the user profile for autofill or records update.</p>
                </div> */}
        <div
          className="text-center d-flex flex-column align-items-center p-2"
          onClick={() => handleLinkedFieldChange("patientProfile")}
        >
          <RiUser3Fill size={70} />
          <b>Link to Patient Profile</b>
          <p className="text-muted">
            Link this field to the patient profile for autofill or records
            update.
          </p>
        </div>
      </div>
    );

  if (loading) {
    return (
      <div className="text-center">
        <FontAwesomeIcon className="me-2" icon={faSpinner} spin />
        Loading Linked Field...
      </div>
    );
  }
  return (
    <div className="p-2 position-relative">
      {/* Slide-in message */}
      {showSlide && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 100,
            background: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            transition: "transform 0.3s",
            transform: "translateY(0)",
            padding: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60px",
          }}
        >
          {slideMessage?.type === "loading" && (
            <>
              <FontAwesomeIcon className="me-2" icon={faSpinner} spin />
              {slideMessage.text}
            </>
          )}
          {slideMessage?.type === "success" && (
            <>
              <FontAwesomeIcon
                className="me-2 text-success"
                icon={faCheckCircle}
              />
              {slideMessage.text}
            </>
          )}
          {slideMessage?.type === "error" && (
            <>
              <FontAwesomeIcon
                className="me-2 text-danger"
                icon={faExclamationTriangle}
              />
              {slideMessage.text}
              <button
                className="btn btn-outline-secondary ms-3"
                onClick={() => setShowSlide(false)}
              >
                Dismiss
              </button>
            </>
          )}
        </div>
      )}
      {/* <h5>Linked Field: {linkedField}</h5> */}
      <div className="mb-3">
        {/* <label>Link Type:</label> */}
        {patientProfileFields.length > 0 ? (
          <select
            className="form-select mb-2"
            value={linkedField}
            onChange={(e) => handleLinkedFieldChange(e.target.value)}
          >
            {patientProfileFields.map((field) => (
              <optgroup key={field.group} label={field.group}>
                {field.fields.map((f) => (
                  <option key={f.id} value={f.id}>
                    {f.name}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        ) : (
          <p>No Patient Profile Fields Available</p>
        )}
        <ToggleButton
          style={{ type: "tick" }}
          defaultValue={linkTypes.includes("autofill")}
          onToggle={() => handleLinkTypeChange("autofill")}
        >
          <div className="d-flex align-items-center align-content-center mb-2">
            <div>
              <RiMarkPenFill size={30} />
            </div>
            <div>
              <b>Autofill</b>
              <p className="text-muted">
                This will fill in the field with the linked value if not
                specified in the questionnaire
              </p>
            </div>
          </div>
        </ToggleButton>
        <ToggleButton
          style={{ type: "tick" }}
          defaultValue={linkTypes.includes("recordsUpdate")}
          onToggle={() => handleLinkTypeChange("recordsUpdate")}
        >
          <div className="d-flex align-items-center align-content-center mb-2">
            <div>
              <RiMarkPenFill size={30} />
            </div>
            <div>
              <b>Records Update</b>
              <p className="text-muted">
                This will update the users records based on the value specified
                in the questionnaire
              </p>
            </div>
          </div>
        </ToggleButton>
      </div>
      <button className="btn btn-success" onClick={handleLinkUpdate}>
        Update Link
      </button>
      <button className="btn btn-danger ms-2" onClick={handleLinkRemove}>
        Remove Link
      </button>
    </div>
  );
}
